import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageBannersList,
  PageBanner,
} from '../pages/banners';

const RouteBanners = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageBannersList />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageBanner />
      </Route>
    </Switch>
  );
};

export default RouteBanners;
